import { LinkOutbound } from '@/components/common/Link'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { usePage } from '@/components/providers/PageProvider'
import { DATEFORMAT_FULL } from '@/defs/date'
import { formatDate, formatPrice, formatSalt } from '@/utils/formatUtil'

import styles from './DecklistDetails.module.scss'

export const DecklistDetails = () => {
  const { page } = usePage()
  const { price, salt, savedate, tags, url } = page?.decklist || {}

  let linkLabel = 'Link'
  if (url?.toLowerCase().includes('archidekt')) linkLabel = 'archidekt.com'
  if (url?.toLowerCase().includes('moxfield')) linkLabel = 'moxfield.com'
  const link = url && (
    <LinkOutbound className={styles.link} href={url} utm={{ medium: 'decklist' }}>
      {linkLabel}
    </LinkOutbound>
  )

  return (
    <table className={styles.container}>
      <thead>
        <tr>
          <th colSpan={2}>
            <h2>Deck Details</h2>
          </th>
        </tr>
      </thead>
      <tbody>
        {price !== undefined && (
          <tr>
            <th>Price</th>
            <td>{formatPrice(price)}</td>
          </tr>
        )}
        {salt !== undefined && (
          <tr>
            <th>Salt</th>
            <td>
              <IconWithLabel iconBefore='salt'>{formatSalt(salt)}</IconWithLabel>
            </td>
          </tr>
        )}
        {savedate !== undefined && (
          <tr>
            <th>Updated</th>
            <td>{formatDate(savedate, DATEFORMAT_FULL)}</td>
          </tr>
        )}
        <tr>
          <th>Tags</th>
          <td>{tags?.join(', ') || ''}</td>
        </tr>
        {link !== undefined && (
          <tr>
            <th>Source</th>
            <td>{link}</td>
          </tr>
        )}
      </tbody>
    </table>
  )
}
